/**
 * Plaque Personalization - Live preview and character counting
 * For products tagged with "plaque" on The Metal Casting Store
 */
(function () {
  'use strict';

  function initPlaque(container) {
    if (!container) return;

    const line1Input = container.querySelector('[name="properties[Plaque Line 1]"]');
    const line2Input = container.querySelector('[name="properties[Plaque Line 2]"]');
    const notesInput = container.querySelector('[name="properties[Plaque Notes]"]');
    const previewLine1 = container.querySelector('.plaque-personalization__preview-line1');
    const previewLine2 = container.querySelector('.plaque-personalization__preview-line2');
    const charCountEls = container.querySelectorAll('.plaque-personalization__char-current');

    if (!line1Input || !previewLine1) return;

    function updatePreview() {
      const val1 = line1Input.value.trim();
      const val2 = line2Input ? line2Input.value.trim() : '';

      previewLine1.textContent = val1 || 'YOUR TEXT HERE';
      if (previewLine2) {
        previewLine2.textContent = val2;
      }
    }

    function updateCharCount(input, counterEl) {
      if (!counterEl) return;
      counterEl.textContent = input.value.length;
    }

    const inputs = [line1Input, line2Input, notesInput].filter(Boolean);

    inputs.forEach(function (input, index) {
      const counterEl = charCountEls[index] || null;

      input.addEventListener('input', function () {
        updateCharCount(input, counterEl);
        updatePreview();
      });

      input.addEventListener('keyup', function () {
        updateCharCount(input, counterEl);
        updatePreview();
      });
    });

    // Validate line 1 is filled before add to cart
    const form = container.closest('form[data-type="add-to-cart-form"]');
    if (form) {
      form.addEventListener('submit', function (e) {
        if (!line1Input.value.trim()) {
          e.preventDefault();
          e.stopPropagation();
          line1Input.focus();
          line1Input.style.borderColor = '#c0392b';
          line1Input.style.boxShadow = '0 0 0 3px rgba(192,57,43,0.15)';

          setTimeout(function () {
            line1Input.style.borderColor = '';
            line1Input.style.boxShadow = '';
          }, 3000);
        }
      });
    }
  }

  // Initialize on DOM ready
  function init() {
    document.querySelectorAll('.plaque-personalization').forEach(initPlaque);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init on Shopify section rendering (theme editor)
  document.addEventListener('shopify:section:load', function () {
    setTimeout(init, 100);
  });
})();
